import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "../site/Motion";
import { AssetCard } from "../site/AssetCard";
import { SourcingNotice } from "../site/SourcingNotice";

export const InventoryPreview = ({ featured = [], recent = [] }) => {
  const [tab, setTab] = useState(featured.length ? "featured" : "recent");
  const items = tab === "featured" ? featured : recent;
  const hasAny = featured.length + recent.length > 0;

  return (
    <section className="py-24 md:py-32 bg-[var(--ink-2)] border-y hairline" data-testid="inventory-preview">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-12">
          <Reveal>
            <p className="eyebrow">Inventory</p>
            <h2 className="font-display text-5xl md:text-6xl text-slate-50 mt-5 leading-[1]">Current <em>listings.</em></h2>
          </Reveal>
          <Reveal delay={0.1} className="flex flex-wrap gap-3">
            <Link to="/inventory" className="btn-gold" data-testid="home-view-all-inventory-button">View All Inventory <ArrowRight className="w-4 h-4" /></Link>
            <Link to="/sourcing" className="btn-ghost" data-testid="home-sourcing-request-button">Request an Asset</Link>
          </Reveal>
        </div>
        {hasAny ? (
          <>
            <div className="flex gap-8 border-b hairline mb-10">
              {[["featured", "Featured", featured.length], ["recent", "Recently Added", recent.length]].map(([k, label, n]) => (
                <button key={k} onClick={() => setTab(k)} disabled={!n}
                  className={`relative pb-4 text-sm tracking-wide transition-colors disabled:opacity-40 ${tab === k ? "text-gold" : "text-slate-300 hover:text-slate-100"}`}
                  data-testid={`inventory-tab-${k}`}>
                  {label} <span className="font-mono text-xs ml-1">({n})</span>
                  {tab === k && <span className="absolute -bottom-px left-0 right-0 h-px bg-[var(--gold)]" />}
                </button>
              ))}
            </div>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {items.map((a, i) => <AssetCard key={a.id} asset={a} index={i} />)}
            </div>
          </>
        ) : (
          <Reveal><SourcingNotice testid="home-sourcing-notice" /></Reveal>
        )}
      </div>
    </section>
  );
};
